export const FETCH_DASHBOARD_INIT = 'FETCH_DASHBOARD_INIT';
export const FETCH_DASHBOARD_DONE = 'FETCH_DASHBOARD_DONE';
export const FETCH_DASHBOARD_FAIL = 'FETCH_DASHBOARD_FAIL';

export const BOOKMARKS_UPDATED = 'BOOKMARKS_UPDATED';
